import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useGame } from '../context/GameContext';
import { WinAnimation } from '../components/WinAnimation';
import './CasinoRoulette.css';

const RED = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];

export function CasinoRoulette() {
  const { gameState, placeBet, addBalance, setLastWin, recordSpin, betOptions } = useGame();
  const [result, setResult] = useState<number | null>(null);
  const [spinning, setSpinning] = useState(false);
  const [choice, setChoice] = useState<'red' | 'black' | null>(null);
  const [lastWin, setLastWinLocal] = useState(0);
  const [showWinAnim, setShowWinAnim] = useState(false);

  const canSpin = choice !== null && gameState.balance >= gameState.bet && !spinning;

  const spin = useCallback(() => {
    if (!canSpin) return;
    const bet = gameState.bet;
    addBalance(-bet);
    setSpinning(true);
    setResult(null);

    setTimeout(() => {
      const num = Math.floor(Math.random() * 37);
      setResult(num);
      const isRed = RED.includes(num);
      const won = (choice === 'red' && isRed) || (choice === 'black' && num > 0 && !isRed);
      const win = won ? bet * 2 : 0;
      if (win > 0) {
        setLastWin(win);
        setLastWinLocal(win);
        setShowWinAnim(true);
        recordSpin(true);
      } else recordSpin(false);
      setSpinning(false);
    }, 2500);
  }, [canSpin, choice, gameState.bet, addBalance, setLastWin, recordSpin]);

  return (
    <div className="casino-roulette">
      {showWinAnim && lastWin > 0 && (
        <WinAnimation amount={lastWin} isBonus={false} onEnd={() => setShowWinAnim(false)} />
      )}
      <div className="casino-roulette-container">
        <Link to="/" className="casino-back">← Takaisin</Link>
        <div className="casino-balance-bar">
          <span className="balance-value">€{gameState.balance}</span>
          <select value={gameState.bet} onChange={(e) => placeBet(Number(e.target.value))} disabled={spinning} className="bet-select">
            {betOptions.map((b) => (
              <option key={b} value={b}>€{b % 1 ? b.toFixed(1) : b}</option>
            ))}
          </select>
        </div>
        <h1 className="roulette-title">🎡 Ruletti</h1>
        <p className="roulette-rules">Punainen tai musta – voitto 2×</p>
        <div className={`roulette-wheel ${spinning ? 'spinning' : ''}`}>
          <div className="roulette-ball">{result !== null ? result : '?'}</div>
        </div>
        {result !== null && (
          <div className={`roulette-result ${RED.includes(result!) ? 'red' : 'black'}`}>
            {result === 0 ? 'Vihreä 0' : RED.includes(result) ? 'Punainen' : 'Musta'} – {result}
          </div>
        )}
        {!spinning && (
          <div className="roulette-choices">
            <button type="button" className={`roulette-btn red ${choice === 'red' ? 'active' : ''}`} onClick={() => setChoice('red')}>Punainen</button>
            <button type="button" className={`roulette-btn black ${choice === 'black' ? 'active' : ''}`} onClick={() => setChoice('black')}>Musta</button>
          </div>
        )}
        <button type="button" className="spin-button" onClick={spin} disabled={!canSpin}>
          {spinning ? 'Pyörii...' : `Pelaa €${gameState.bet}`}
        </button>
      </div>
    </div>
  );
}
